import { AICC_PROMPT_GROUP, AiccPromptGroup } from "constants/aiccPrompt";
import { AICC_SANDBOX_MODE, AiccSandboxMode } from "constants/aiccPromptSandbox";

export const SANDBOX_MODE_BY_GROUP: Partial<Record<AiccPromptGroup, AiccSandboxMode>> = {
  [AICC_PROMPT_GROUP.onboarding]: AICC_SANDBOX_MODE.onboarding,
  [AICC_PROMPT_GROUP.scenarioConversation]: AICC_SANDBOX_MODE.scenarioConversation,
  [AICC_PROMPT_GROUP.lessonReview]: AICC_SANDBOX_MODE.lessonReview,
};

export const ONBOARDING_VARIANTS = ["onboarding_new_user", "onboarding_reset"];

// 🔴 Scenario refuses `variant` with a 400; lesson review names its judge, since `lesson_review_main` reaches no model.
export const flowVariant = (mode: AiccSandboxMode, onboardingVariant: string) =>
  ({
    [AICC_SANDBOX_MODE.onboarding]: onboardingVariant,
    [AICC_SANDBOX_MODE.scenarioConversation]: undefined,
    [AICC_SANDBOX_MODE.lessonReview]: "lesson_review_judge",
  }[mode]);

export const hasWrapUp = (mode: AiccSandboxMode) => mode === AICC_SANDBOX_MODE.scenarioConversation;

// 🔴 Onboarding greets from its own prompt, so it has no `conversation_starter` for the flag to choose between.
export const hasOpenerVariant = (mode: AiccSandboxMode) => mode === AICC_SANDBOX_MODE.scenarioConversation;

export const hasSideActions = (mode: AiccSandboxMode) => mode === AICC_SANDBOX_MODE.scenarioConversation;

export const hasSupportingFunctions = (mode: AiccSandboxMode) => mode !== AICC_SANDBOX_MODE.onboarding;

export const hasHint = (mode: AiccSandboxMode) => mode !== AICC_SANDBOX_MODE.onboarding;

export const hasLesson = (mode: AiccSandboxMode) => mode === AICC_SANDBOX_MODE.lessonReview;

export const hasVariantChoice = (mode: AiccSandboxMode) => mode === AICC_SANDBOX_MODE.onboarding;
